import { GetContextMenuItemsParams } from 'ag-grid-community'
import { ContextualMenuItem } from 'ts/types/commonTable.types'
import { copyValueMenuItem } from './copyValueMenuItem'
import { decideMenuItem } from './decideMenuItem'
import { openInPriceHubMenuItem } from './openInPriceHubMenuItem'

/**
 * Converts AG Grid menu item format to Material-UI ContextualMenuItem format
 */
const convertAgGridMenuItemToMUI = (agMenuItem: any, onClose: () => void): ContextualMenuItem => {
  // Extract icon from HTML string if present
  let iconSrc = null
  if (agMenuItem.icon && typeof agMenuItem.icon === 'string') {
    try {
      const match = agMenuItem.icon.match(/src="([^"]+)"/)
      if (match?.[1]) {
        iconSrc = match[1]
      }
    } catch (error) {
      console.warn('Failed to extract icon src:', error)
    }
  }

  return {
    content: agMenuItem.name,
    onClick: () => {
      if (agMenuItem.action) {
        agMenuItem.action()
      }
      onClose() // Close menu after action
    },
    icon: iconSrc,
    disabled: agMenuItem.disabled || false,
  }
}

/**
 * Get row context menu items in Material-UI format
 */
export const getRowContextMenuItemsForMUI = (
  params: GetContextMenuItemsParams,
  onClose: () => void
): ContextualMenuItem[] => {
  if (!params.node?.data) {
    return []
  }

  const agMenuItems = [
    decideMenuItem(params),
    openInPriceHubMenuItem(params),
    copyValueMenuItem(params),
  ].filter((menuItem) => !!menuItem)

  // Convert AG Grid format to MUI format
  return agMenuItems.map((item) => convertAgGridMenuItemToMUI(item, onClose))
}
